export default __webpack_public_path__ + "static/media/logo-zero-mais-branco.8e9c3bb2.png";